import { GraphQLError } from 'graphql/error';

const getErrorByCode = (error: { graphQLErrors: ReadonlyArray<GraphQLError> }, code: string) =>
  error.graphQLErrors && error.graphQLErrors.find((graphQLError) => graphQLError.extensions?.code === code);

export default getErrorByCode;
